import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { markProjectIqWorkspaceUpdated } from "redux/projectIqWorkspacesSlice";
import { completeWorkspaceAnalyticCreation } from "apps/project-iq/api";

// Persists the activity so the workspace stays ordered after a reload, then
// reorders the sidebar's in-memory copy straight away.
export const useMarkAnalyticsWorkspaceUpdated = (
  workspaceId: string,
): ((projectId: string) => Promise<void>) => {
  const dispatch = useDispatch();
  return useCallback(
    async (projectId: string): Promise<void> => {
      try {
        await completeWorkspaceAnalyticCreation({ workspaceId, projectId });
        dispatch(markProjectIqWorkspaceUpdated(workspaceId));
      } catch {
        void 0;
      }
    },
    [dispatch, workspaceId],
  );
};
